import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@sb/ui';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class MetaInterceptor implements HttpInterceptor {
  public constructor(private toast: ToastService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body?.meta) {
          const { meta } = event.body;
          const ignoreMetaMessage = request?.headers.get('ignore-meta-message') === 'true';

          if (meta.request && meta.request.remote_addr) {
            environment.ipAddress = meta.request.remote_addr;
          }

          if (meta.status === 'ok' && meta.status_message && !ignoreMetaMessage) {
            this.toast.openSuccess(meta.status_message);
          }
        }
      }),
    );
  }
}
